import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'


const firebaseConfig = {
  apiKey: "AIzaSyCP4UrcScwBZmUnhSvT7y-OROPaEf5Zas0",
  authDomain: "bethel-bible-college.firebaseapp.com",
  projectId: "bethel-bible-college",
  storageBucket: "bethel-bible-college.appspot.com",
  messagingSenderId: "566808722217",
  appId: "1:566808722217:web:2eb00a7e83fd893e24d538",
  measurementId: "G-4E5D6HHWSM"
};

firebase.initializeApp(firebaseConfig)

// init services
const db = firebase.firestore()
const projectAuth = firebase.auth()
const storage = firebase.storage()

// timestamp
const timestamp = firebase.firestore.Timestamp

export { db, storage ,timestamp};

